import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TooltipModule, PopoverModule } from 'ngx-bootstrap';
import { PipesModule } from 'src/app/core/pipes/pipes.module';
import { AvailableDocumentsComponent } from './available-documents.component';
import { DocumentsTreeModule } from '../documents-tree/documents-tree.module';

@NgModule({
  declarations: [AvailableDocumentsComponent],
  imports: [
    CommonModule,
    FormsModule,
    TooltipModule.forRoot(),
    PopoverModule.forRoot(),
    PipesModule,
    DocumentsTreeModule
  ],
  exports: [AvailableDocumentsComponent],
  entryComponents: [AvailableDocumentsComponent]
})
export class AvailableDocumentsModule { }
